import {
  Button,
  Flex,
  Input,
  Modal,
  notification,
  Space,
  Spin,
  Table,
  Upload,
  UploadFile,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useTypedSelector } from "../../store";
import { getLeavesRequest, uploadCTAllowanceRequest } from "../../slices/leave";
import {
  SearchOutlined,
  FileExcelOutlined,
  UploadOutlined,
  LoadingOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import { RcFile } from "antd/es/upload";
import { UploadFileStatus } from "antd/es/upload/interface";
const LeaveList: React.FC = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalUpload, setIsModalUpload] = useState<boolean>(false);
  const [isUploadProcess, setIsUploadProcess] = useState<boolean>(false);
  const [fileList, setFileList] = useState<UploadFile<any>[]>([]);

  const { loading, leaves, upload } = useTypedSelector((state) => {
    return {
      loading: state.Leave.pageIsLoading,
      leaves: state.Leave.leaves,
      upload: state.Leave.uploadCTAllowance,
    };
  });

  useEffect(() => {
    dispatch(getLeavesRequest() as any);
  }, []);
  useEffect(() => {
    dispatch(getLeavesRequest() as any);
  }, [upload]);

  console.log(leaves);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: any) => (
        <Link to={`/leave/${record._id}`}>{text}</Link>
      ),
    },
    {
      title: "Employee ID",
      dataIndex: "_id",
      key: "_id",
    },
    {
      title: "CT Allocated",
      dataIndex: "ctAllowanceAllocated",
      key: "ctAllowanceAllocated",
    },
    {
      title: "CT Usage",
      dataIndex: "ctAllowanceUsage",
      key: "ctAllowanceUsage",
    },
    {
      title: "CT Remaining",
      dataIndex: "ctAllowanceRemaining",
      key: "ctAllowanceRemaining",
    },
    { title: "PH Usage", dataIndex: "phUsage", key: "phUsage" },
    { title: "PH Remaining", dataIndex: "phRemaining", key: "phRemaining" },
  ];

  const filteredLeave = leaves.filter(
    (lea) =>
      lea.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lea._id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // template download
  const downloadCTAllowanceTemplate = () => {
    const headers = [
      "employeeId",
      "year",
      "allocatedDays",
      "usedDays",
      "remainingDays",
    ];
    const data = [["DB0001", 2025, 12, 2, 10]];

    // Create a worksheet with the headers and sample data
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "CT Leave Template");

    // Write the workbook to a file and trigger the download
    XLSX.writeFile(workbook, "ct_allowance_template.xlsx");
  };

  const uploadProps = {
    onRemove: (file: UploadFile<any>) => {
      setFileList((prevFileList) =>
        prevFileList.filter((f) => f.uid !== file.uid)
      );
    },
    beforeUpload: (file: File & RcFile) => {
      const uploadFile: UploadFile<any> = {
        uid: file.uid || file.name, // Gunakan UID atau nama file
        name: file.name,
        status: "done" as UploadFileStatus,
        originFileObj: file,
      };
      setFileList([uploadFile]);
      return false; // Prevent automatic upload
    },
    fileList,
  };

  const handleUpload = () => {
    setIsUploadProcess(true);
    if (fileList.length === 0) {
      notification.warning({
        message: "Please select a file before uploading.",
      });
      return;
    }

    const formData = new FormData();
    fileList.forEach((file) => {
      if (file.originFileObj) {
        formData.append("data", file.originFileObj as File);
        dispatch(uploadCTAllowanceRequest(formData) as any);
      }
    });
  };

  const handleExportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredLeave);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "leave");
    XLSX.writeFile(wb, "leave.xlsx");
  };
  return (
    <div>
      <Space
        style={{
          marginBottom: 16,
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Input
          placeholder="Search by Name or ID"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: 16, maxWidth: "300px" }}
        />

        <div>
          <Button
            icon={<DownloadOutlined />}
            style={{
              backgroundColor: "#00a65a",
              color: "white",
              marginRight: 10,
              borderColor: "#00a65a",
            }}
            onClick={() => downloadCTAllowanceTemplate()}
          >
            Download Template Excel
          </Button>
          <Button
            icon={<UploadOutlined />}
            style={{
              backgroundColor: "#00a65a",
              color: "white",
              marginRight: 10,
              borderColor: "#00a65a",
            }}
            onClick={() => setIsModalUpload(true)}
          >
            Upload CT Allowance
          </Button>

          <Button
            type="primary"
            icon={<FileExcelOutlined />}
            style={{ backgroundColor: "#00a65a", borderColor: "#00a65a" }}
            onClick={handleExportToExcel}
          >
            Export to Excel
          </Button>
        </div>
      </Space>
      <Table dataSource={filteredLeave} columns={columns} rowKey="_id" />

      <Modal
        title="Upload Employee Confirm"
        open={isModalUpload}
        footer={null}
        onCancel={() => {
          setIsModalUpload(false);
          setIsUploadProcess(false);
          setFileList([]);
        }}
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "300px", // Sesuaikan tinggi modal
        }}
      >
        <Upload {...uploadProps} accept=".xlsx,.xls">
          <Button
            icon={<UploadOutlined />}
            style={{ width: 300, marginBottom: 20 }}
          >
            Select File
          </Button>
        </Upload>
        <Button
          type="primary"
          onClick={handleUpload}
          style={{
            backgroundColor: "#217346", // Warna hijau khas Excel
            borderColor: "#217346", // Sesuaikan border dengan warna latar belakang
            color: "#fff",
            width: 300, // Warna teks putih
          }}
        >
          {!loading && <>Upload CT Allowance</>}
          {loading && (
            <>
              <Flex align="center" gap="middle">
                <Spin indicator={<LoadingOutlined spin />} size="small" />
              </Flex>
            </>
          )}
        </Button>
        {upload && isUploadProcess === true && (
          <>
            <p style={{ color: "red", marginBottom: 0 }}>
              FAIL : {upload.failUpload}
            </p>
            <p style={{ color: "green", marginTop: 0 }}>
              SUCCESS : {upload.totalUpload - upload.failUpload}
            </p>
          </>
        )}
      </Modal>
    </div>
  );
};

export default LeaveList;
